import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'
import { useHistory } from 'react-router'
import { formatRenderToDate } from '../../../../utils/functions';

import Render from './RegisterRender'

function Register ({ ancoraid }) {
  const history = useHistory()

  const [inputs, setInputs] = useState({
    status: 'Ativo'
  })
  const [getErros, setErros] = useState([])
  const [getLoading, setLoading] = useState(false)
  const dispatch = useDispatch()

  const handleInputChange = (event, value) => {
    event.persist()
    setInputs(inputs => ({ ...inputs, [event.target.name]: value || event.target.value }))
  }

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-taxas-faixas'))

    const permissions = getPermissions({ moduloId: 1344, permissao: 'Cadastrar' })
    if (!permissions) {
      history.push('/app')
    }
  }, [])

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault()

      setLoading(true)
      try {
        const response = await api.post('AncorasTaxasFaixas', {
          ...inputs,
          ancoraId: parseInt(ancoraid),
          valorInicial: inputs.valorInicial ? parseFloat(inputs.valorInicial) : 0,
          valorFinal: inputs.valorFinal ? parseFloat(inputs.valorFinal) : 0,
          taxa: inputs.taxa ? parseFloat(inputs.taxa) : 0,
          dataInicioCobranca: inputs.dataInicioCobranca ? formatRenderToDate(inputs.dataInicioCobranca) : '',
          dataFinalCobranca: inputs.dataFinalCobranca ? formatRenderToDate(inputs.dataFinalCobranca) : ''
        })
        if (response.data.status !== 'Inconsistencia') {
          setInputs({})
          toast.success('Taxas faixas registrada com sucesso!')
        } else {
          if (response.data.resposta[0].key) {
            const errosArray = []

            response.data.resposta.map(resposta => {
              errosArray.push(resposta.key)
              toast.error(resposta.key + ' - ' + resposta.message)
              return null
            })

            setErros(errosArray)
          } else {
            toast.error('Não foi possível adicionar a nova âncoras taxa faixas!')
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message)
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.')
        }
      }
      setLoading(false)
    }
  }

  return <Render
    inputs={inputs}
    getErros={getErros}
    setErros={setErros}
    getLoading={getLoading}
    handleInputChange={handleInputChange}
    onSubmit={handleSubmit}
  />
}

export default Register
